<template>
  <v-card>
    <v-card-title>
      <div class="d-flex flex-row mb-0 above-table">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Recherche (par : Titre, URL)"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-switch
          class="filter-active mr-2"
          v-model="onlyActive"
          label="Seulement les actifs"
          outlined
          dense
        ></v-switch>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        locale="fr-FR"
        :headers="headers"
        :items="filteredItems"
        :sort-by="'updated'"
        :sort-desc="true"
        :loading="loading"
        class="elevation-1"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :items-per-page="25"
      >
        <template v-slot:item.site_name="{ item }">
          {{ getSiteName(item.site_id) }}
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-chip
            :color="item.is_active ? 'green' : 'red'"
            dark
            small
          >
            {{ item.is_active ? 'Actif' : 'Inactif' }}
          </v-chip>
        </template>
        <template v-slot:item.next_check_time="{ item }">
          {{ formatDateTime(item.next_check_time) }}
        </template>
        <template v-slot:item.updated="{ item }">
          {{ formatDateTime(item.updated) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <a target="_blank">
            <v-btn
              :to="`/web-perf/synthetic-monitoring-add-edit/${item.id}`"
              class="mx-2"
              elevation="0"
              fab
              small
            >
              <v-icon color="primary">
                {{ icons.mdiPencil }}
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              elevation="0"
              fab
              small
              @click.native="
                dialogModel.dialog = !dialogModel.dialog;
                dialogModel.id = item.id;
                dialogModel.title = item.title;
              "
            >
              <v-icon color="secondary">
                {{ icons.mdiTrashCan }}
              </v-icon>
            </v-btn>
          </a>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog v-model="dialogModel.dialog" width="70vw">
      <del-confirmation
        :dialogOpen="dialogModel.dialog"
        :id="dialogModel.id"
        :name="dialogModel.title"
        @openDialog="openDialog"
      ></del-confirmation>
    </v-dialog>
  </v-card>
</template>

<script>
import DelConfirmation from "@/components/web-perf/synthetic-monitoring/modals/UrlMonitorDelConfirmation.vue";
import { mdiPencil, mdiTrashCan } from "@mdi/js";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "UrlMonitorsTable",
  components: { DelConfirmation },
  data() {
    return {
      search: "",
      onlyActive: false,
      loading: true,
      headers: [
        {
          text: "Titre",
          align: "start",
          sortable: true,
          value: "title",
        },
        {
          text: "URL",
          value: "url",
          sortable: true,
        },
        {
          text: "Site",
          value: "site_name",
          sortable: true,
        },
        {
          text: "Intervalle (min)",
          value: "interval_minutes",
          sortable: true,
        },
        {
          text: "Status",
          value: "is_active",
          sortable: true,
        },
        {
          text: "Prochaine vérification",
          value: "next_check_time",
          sortable: true,
        },
        {
          text: "Dernière modification",
          value: "updated",
          sortable: true,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      dialogModel: {
        dialog: false,
        id: null,
        title: "",
      },
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
    };
  },
  computed: {
    ...mapGetters("common", ["getSiteList"]),
    ...mapGetters("webPerf", ["getUrlMonitors"]),
    siteList() {
      return this.getSiteList;
    },
    filteredItems() {
      let filtered = this.getUrlMonitors;
      
      // Apply active filter
      if (this.onlyActive) {
        filtered = filtered.filter(item => item.is_active);
      }
      
      // Add site_name property for display
      filtered = filtered.map(item => ({
        ...item,
        site_name: this.getSiteName(item.site_id)
      }));
      
      return filtered;
    },
  },
  watch: {
    onlyActive() {
      // Filter will be applied automatically through computed property
    },
  },
  async mounted() {
    // Load site list from store
    if (this.getSiteList.length === 0) {
      await this.$store.dispatch("common/getSiteList");
    }
    
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        await this.$store.dispatch("webPerf/getUrlMonitors");
      } catch (error) {
        console.error("Error fetching URL monitors:", error);
        this.$store.dispatch("alerts/addAlert", {
          message: "Erreur lors du chargement des monitors",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(dateString) {
      if (!dateString) return "-";
      try {
        return moment(dateString).format("DD/MM/YYYY HH:mm");
      } catch (error) {
        return dateString;
      }
    },
    openDialog(state) {
      this.dialogModel.dialog = state;
      if (!state) {
        this.getData(); // Refresh data when dialog closes
      }
    },
    getSiteName(siteId) {
      if (!siteId) return "-";
      const site = this.siteList.find(s => s.id === siteId);
      return site ? site.name : `Site ID: ${siteId}`;
    },
  },
};
</script>

<style scoped>
.above-table {
  width: 100%;
}
.filter-active {
  min-width: 180px;
}
</style>